// @ts-nocheck
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { BlockParsedBaseProps } from "@store/Library/Components/Toolkit/Block/Block";
import { BlockVariantBaseProps, BlockVariantTypeProps } from "@store/Library/Components/Toolkit/Block/variant/base";
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { blockContainerClearFixStyles } from "@store/Library/Components/Toolkit/Block/mixins";
/* Store Custom Code - End */

export interface BlockVariantAlternativeBaseProps {
    backgroundColor?: string;
}
export interface BlockVariantAlternativeProps extends BlockVariantBaseProps, BlockVariantAlternativeBaseProps {}

const typeProps: BlockVariantTypeProps<BlockVariantAlternativeProps> = {
    defaultProps: {
        backgroundColor: "common.accent",
    },
    staticProps: {
        containerCss: css<BlockParsedBaseProps>`
            ${blockContainerClearFixStyles() /* Store Custom Code */}

            ${({ theme, variantProps }) => {
                const backgroundColor = variantProps.alternative.backgroundColor;

                if (backgroundColor) {
                    return `background-color: ${resolveColor(backgroundColor, theme)};`;
                }
            }}
        `,
    },
};

export default typeProps;
